import { render, staticRenderFns } from "./SignupComplete.vue?vue&type=template&id=50a93bfc&lang=pug&"
import script from "./SignupComplete.vue?vue&type=script&lang=ts&"
export * from "./SignupComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports